<template>
  <a-table
    :columns="absenceReportColumns"
    :data-source="absenceReports"
    :pagination="false"
    :loading="loadingTable"
    :row-key="(report) => report.id"
    size="middle"
  >
    <template #absenceType="type, report">
      <span>
        <a-badge :color="getReportBadge(type)" />
        {{ getReportLabel(type) }}
        <span v-if="type === ReportType.PARENTAL"> ({{ report.parental_percentage * 100 }}%) </span>
      </span>
    </template>
  </a-table>
</template>

<script setup lang="ts">
import { ReportInterface, ReportType } from "../../reports/types";
import { absenceReportColumns } from "../_utils/tables";
import Colors from "@/assets/scss/_colors.module.scss";

// Props
const props = defineProps({
  absenceReports: { type: Array as () => Array<ReportInterface>, default: undefined },
  loadingTable: { type: Boolean, default: undefined },
});

// Component methods
const getReportBadge = (type: string): string => {
  switch (type) {
    case ReportType.VACATION:
      return `${Colors.lemon}`;
    case ReportType.PARENTAL:
      return `${Colors.solitude}`;
    case ReportType.ABSENCE:
      return `${Colors.solitude}`;
  }
  return type;
};

const getReportLabel = (type: string): string => {
  switch (type) {
    case ReportType.VACATION:
      return "Vacation";
    case ReportType.PARENTAL:
      return "Parental leave";
    case ReportType.ABSENCE:
      return "Leave of absence";
  }
  return type;
};
</script>
